import {css} from 'lit';

export default css`
  :host {
    background-color: var(--identity-lowVisibility);
    padding: var(--gap);
    display: block;
  }

  :host([variant='B']) {
    background: linear-gradient(180deg, rgba(28, 138, 217, 0.10) 0%, rgba(0, 0, 0, 0.70) 77.88%, rgba(255, 216, 0, 0.50) 100%);
    padding: 0;
    height: 36rem;
  }
  :host([variant='B'][brand='GMX']) {
    background: linear-gradient(180deg, #475C89 0%, #7F92BD 77.88%, #475C89 100%);
    padding: 0;
    height: 36rem;
  }

  :host([variant='C']) {
    background: radial-gradient(120.15% 115.04% at 3.99% 8.49%, rgba(255, 216, 0, 0.50) 0%, rgba(174, 199, 255, 0.50) 100%);
    padding: 0;
    height: 36rem;
  }
  :host([variant='C'][brand='GMX']) {
    background: radial-gradient(160.18% 141.42% at 0% 0%, rgba(146, 225, 251, 0.50) 0%, rgba(110, 152, 4, 0.50) 100%);
    padding: 0;
    height: 36rem;
  }

  :host([variant='D']) {
    background: radial-gradient(120.15% 115.04% at 3.99% 8.49%, rgba(255, 216, 0, 0.50) 0%, rgba(174, 199, 255, 0.50) 100%);
    padding: 0;
    height: 36rem;
  }
  :host([variant='D'][brand='GMX']) {
    background: linear-gradient(142deg, rgba(28, 68, 155, 0.10) 0%, rgba(28, 68, 155, 0.40) 100%);
    padding: 0;
    height: 36rem;
  }


  form {
    display: flex;
    flex-direction: column;
    padding-top: 2rem;
    gap: 30px;
  }

  form.variant {
    position: relative;
    justify-content: flex-end;
    padding-top: 0;
    gap: 1.2rem;
    height: 100%;
  }

  label {
    width: 100%;
  }

  p, h2 {
    padding: 0;
    margin: 0;
  }

  h2 {
    font-size: 2.4rem;
    line-height: 3.2rem;
  }

  h2.floating {
    font-size: 3.2rem;
    line-height: 4.2rem;
    color: white;
    padding-left: 2rem;
    z-index: 1;
  }

  h2.label {
    font-size: 2.2rem;
    line-height: 2.2rem;
    padding-bottom: 1.4rem;
  }

  ul {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: calc(var(--gap) / 2); 
  }

  ul li {
    display: flex;
    align-items: center;
    gap: calc(var(--gap) / 2);
  }

  .check {
    background: var(--regpromotool-check) no-repeat 50% 0 / contain;
    display: inline-block;
    width: 1.9rem;
    height: 2rem;
  }

  .image-wrapper {
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: flex-end;
  }

  .person-image {
    height: 36rem;
    width: auto;
  }

  .blur-layer {
    padding: 2rem;
    background: rgba(0, 0, 0, 0.40);
    backdrop-filter: blur(5px);
    color: white;
  }

  :host([variant='C'][brand='GMX']) .blur-layer,
  :host([variant='D'][brand='GMX']) .blur-layer {
    background: rgba(255, 255, 255, 0.60);
    backdrop-filter: blur(10px);
    color: #333;
  }

  .combo {
    background-color: var(--form-default-background);
    border: 1px solid var(--outline-lowVisibility);
    padding: 0 1rem 0 0;
    border-radius: 0.4rem;
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .combo input {
    flex: 1;
    border-color: transparent;
    padding: 1rem 0 1rem 1rem;
    margin: 0;
  }

  .combo span {
    color: var(--text-lowVisibility);
  }

  .combo input, .combo span {
    font-size: 1.4rem;
    line-height: 2rem;
  }

  button {
    transform: translateY(-10px);
    border: 0;
    background-color: var(--button-primary-default-background);
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 4rem;
    border-radius: 0.4rem;
  }

  button span {
    display: inline-block;
    color: var(--button-primary-default-label);
    font-family: var(--font-family-sans-serif), sans-serif;
    font-weight: bold;
    font-size: 1.6rem;
    line-height: 2.2rem;
  }

  form.variant button {
    transform: none;
    margin-top: 1.4rem;
    width: 100%;
  }
`;
